<fieldset [formGroup]="billingSummary">
  <legend>Extra Mileage Justification</legend>
  <div data-row-span="12">
    <div data-field-span="2" title="Loaded miles actual">
      <label>Loaded Miles</label>
      <input type="text" formControlName="loadedMilesActual" min="0" />
    </div>
    <div data-field-span="2" title="Loaded miles caclulated">
      <label>Calculated Miles</label>
      <input type="number" formControlName="loadedMilesCalculated" min="0" />
    </div>
    <div data-field-span="2" title="Loaded leg count">
      <label>Loaded Legs</label>
      <input type="number" formControlName="loadedLegCount" min="0" />
    </div>
    <div data-field-span="2" title="Total leg count">
      <label>Total Legs</label>
      <input type="number" formControlName="totalLegCount" min="0" />
    </div>
    <div data-field-span="4" title="Comment">
      <label>Comment</label> <input type="text" formControlName="comment" />
    </div>
  </div>
</fieldset>
<fl-message-box [messages]="validationErrors$ | async" [level]="'error'"></fl-message-box>
